var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "56", height: "56", viewBox: "0 0 56 56", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "title",
      null,
      "Universal Login"
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "linearGradient",
        { x1: "50%", y1: "0%", x2: "50%", y2: "97.848%", id: "b" },
        React.createElement("stop", { stopColor: "#CDD2D5", offset: "0%" }),
        React.createElement("stop", { stopColor: "#9A9E9F", offset: "100%" })
      ),
      React.createElement("circle", { id: "a", cx: "28", cy: "28", r: "28" }),
      React.createElement("path", { d: "M11.333 7.333H13a1 1 0 0 1 1 1V17a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V8.333a1 1 0 0 1 1-1h1.667v-3a4.333 4.333 0 1 1 8.666 0v3zm-1.333 0v-3a3 3 0 1 0-6 0v3h6z", id: "e" }),
      React.createElement(
        "filter",
        { x: "-46.4%", y: "-30.6%", width: "192.9%", height: "172.2%", filterUnits: "objectBoundingBox", id: "d" },
        React.createElement("feOffset", { dy: "1", "in": "SourceAlpha", result: "shadowOffsetOuter1" }),
        React.createElement("feGaussianBlur", { stdDeviation: "2", "in": "shadowOffsetOuter1", result: "shadowBlurOuter1" }),
        React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0", "in": "shadowBlurOuter1" })
      )
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement(
        "mask",
        { id: "c", fill: "#fff" },
        React.createElement("use", { xlinkHref: "#a" })
      ),
      React.createElement("use", { fill: "url(#b)", xlinkHref: "#a" }),
      React.createElement(
        "g",
        { mask: "url(#c)" },
        React.createElement(
          "g",
          { transform: "translate(21 18)" },
          React.createElement("use", { fill: "#000", filter: "url(#d)", xlinkHref: "#e" }),
          React.createElement("use", { fill: "#FFF", xlinkHref: "#e" })
        )
      )
    )
  );
});


// WEBPACK FOOTER //
// ./src/pages/universal-login/components/Hero/ul-hero-icon.svg